import brandInfo from "src/environments/brand.json";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { EMPTY, map, switchMap, catchError } from "rxjs";
import { ProspectService } from "../_services/prospect-service.service";
import * as ActionConfigurationManager from "../_actions/config.actions";
import { Store } from "@ngrx/store";
import { RatesResponse } from "../_models/rates";
import { Injectable } from "@angular/core";
import { LoggingService } from "../_services/logging.service";
import { Cart } from "../_models/cart";
import { cartTaxTokenRefreshSuccess, checkoutAVSTokenRefreshSuccess, purchaseContractTokenRefreshSuccess } from "../_actions/token-refresh.actions";
import { Lead } from "../_models/lead";
import { Plan } from "../_models/plan";
import { AVSRequest } from "../_models/avs";
import { submitAVS } from "../_actions/avs.actions";
import { prepCartForOrder } from "../_actions/cart.actions";
import { CartOrderData } from "../_models/order";
import { Opportunity } from "../_models/account";
import { environment } from "src/environments/environment";
import { TaxSubmissionService } from "../_services/tax-submission.service";

@Injectable()
export class TokenRefreshEffects {
  public refreshTokenCart$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ActionConfigurationManager.REFRESH_TOKEN_CART_TAX),
      switchMap((action: any) =>
        this.leadService.get_opportunity_token_refresh(action).pipe(
          map((lead) => {
            console.log('get_opportunity_token_refresh submitTax');
            this.submitTax()
            return cartTaxTokenRefreshSuccess();

          }),
          catchError(() => {
            return EMPTY;
          })
        )
      )
    )
  );

  public refreshTokenAVS$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ActionConfigurationManager.REFRESH_TOKEN_AVS_TAX),
      switchMap((action: any) =>
        this.leadService.get_opportunity_token_refresh(action).pipe(
          map((lead) => {
            let request: AVSRequest = {
              street1: action.street1,
              city: action.city,
              state: action.state,
              country: action.country,
              vin: action.vin,
              email: action.email,
              zip: action.postalCode,
              brandName: brandInfo.brand
            }
            this.store.dispatch(submitAVS(request))
            return checkoutAVSTokenRefreshSuccess();
          }),
          catchError(() => {
            return EMPTY;
          })
        )
      )
    )
  );

  public refreshTokenPurchaseContract$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ActionConfigurationManager.REFRESH_TOKEN_PURCHASE_CONTRACT),
      switchMap((action: any) =>
        this.leadService.get_opportunity_token_refresh(action).pipe(
          map((lead) => {
            let request: CartOrderData = {
              cartData: action.cartData,
              purchaseContractRequest: action.purchaseContractRequest
            }
            this.store.dispatch(prepCartForOrder(request))
            return purchaseContractTokenRefreshSuccess();
          }),
          catchError(() => {
            return EMPTY;
          })
        )
      )
    )
  );

  submitTax() {
    const lead: Lead = JSON.parse(sessionStorage.getItem("lead"));
    const _cart: Cart = JSON.parse(sessionStorage.getItem('cart'));
    const opp: Opportunity = JSON.parse(sessionStorage.getItem('opp'));

    this.taxSubmissionService.submitTaxRequest({
      cart: _cart,
      lead: lead,
      opportunity: opp,
      useSubtotalForSingleProduct: true
    });
  }

  constructor(
    private actions$: Actions,
    private leadService: ProspectService,
    private loggingService: LoggingService,
    public store: Store<{}>,
    private taxSubmissionService: TaxSubmissionService
  ) { }
}
